/**
 * Strategy for Standard Search with Condition Tabs enabled
 * Fetches page results and inventory results for NEW, USED, CERTIFIED in parallel
 */
export async function standardWithConditionTabsStrategy({
	query,
	getPageResults,
	getInventoryResults
}) {
	const [
		pageSearchResponseResult,
		newInventorySearchResponse,
		usedInventorySearchResponse,
		certifiedInventorySearchResponse
	] = await Promise.all([
		getPageResults(query),
		getInventoryResults(query, 'NEW'),
		getInventoryResults(query, 'USED'),
		getInventoryResults(query, 'CERTIFIED')
	]);

	const inventorySearchResponse = {
		new: newInventorySearchResponse,
		used: usedInventorySearchResponse,
		certified: certifiedInventorySearchResponse
	};

	return {
		inventorySearchResponse,
		pageSearchResponse: pageSearchResponseResult
	};
}
